import cloneDeep from 'lodash/cloneDeep';
import genererCritereRechercheCommandeAFacturer
  from '@/services/devisCommandes/genererCritereRechercheCommandeAFacturer';
import * as types from '@/store/modules/commandeAFacturer-mutation-type';
import getAllCommandeAFacturer from '@/api/commandeAFacturer';
import { getPiecesJointeCommandeSignesByIds } from '@/services/piecesJointes/getPiecesJointe';
import commandeAFacturerTransformer
  from '@/services/commande/commandeAFacturer/commandeAFacturerTransformer';
import * as allTypes from '@/store/mutation-type';

function initialState() {
  return {
    commandeAFacturer: [],
    totalCount: 0,
    criteresRecherche: genererCritereRechercheCommandeAFacturer(true),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_COMMANDE_A_FACTURER](state, commandeAFacturer) {
    state.commandeAFacturer = commandeAFacturer;
  },
  [types.SET_TOTAL_COMMANDE_A_FACTURER](state, totalCount) {
    state.totalCount = totalCount;
  },
  [types.SET_CRITERES_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadCommandeAFacturer({ commit }, data) {
    const commandeAFacturer = (await getAllCommandeAFacturer(data)).data.result;
    commandeAFacturer.items.forEach((commande) => {
      commande.selected = false;
    });
    if (data.withCommandesSignees) {
      await getPiecesJointeCommandeSignesByIds(commandeAFacturer.items);
    }
    commit(types.SET_LAST_PAYLOAD, commandeAFacturerTransformer(cloneDeep(data)));
    commit(types.SET_COMMANDE_A_FACTURER, commandeAFacturer.items);
    commit(types.SET_TOTAL_COMMANDE_A_FACTURER, commandeAFacturer.totalCount);
    return {};
  },
};

const getters = {
  commandeAFacturer: state => {
    return state.commandeAFacturer;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
